import { NDAModel } from '@w3lcome/types';

import RequestCreator from './BaseRequest';

const api = new RequestCreator<NDAModel>('/ipad/nda');
export default api;
